import { Card, CardContent, Grid } from '@mui/material';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { DeleteButton } from '../../../components/delete-button.component';
import { projectsApiKeyStore } from '../../../api/projects-api-key-store';
import { useFormContext, useWatch } from 'react-hook-form';
import { Icons } from '../../../assets/icons';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { proctorResultApiKeyStore } from '../../../api/proctor-result-api-key-store';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { useEffect, useRef } from 'react';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';

interface BuildingFloorUnitFormProps {
  name: string;
  index?: number;
  onRemove?: (index: number) => void;
  isEnabled?: boolean;
  syncWithDux: any
}

export const TimeAndMaterialItemForm = ({ name, index, onRemove, syncWithDux, isEnabled = false }: BuildingFloorUnitFormProps) => {
  const { getValues, setValue } = useFormContext();

  const { data, isLoading } = useLoadData<ApiResponse<any>>(
    projectsApiKeyStore.generateLotName(getValues('projectID')),
    isEnabled
  );

  const jobsiteRef = useRef<string | null>(null);

  useWatch({
    name: `${name}.jobsite` || [],
  });

  useEffect(() => {
    if (data && data?.data) {
      setValue(`${name}.jobsite`, data?.data?.unitName);
      jobsiteRef.current = data?.data?.unitName;
    }
  }, [data]);

  const handleUnitNameChange = (value: string) => {
    const initialJobsite = jobsiteRef.current || getValues(`${name}.jobsite`);
    const newJobsite = `${initialJobsite}${value}`.trim();
    setValue(`${name}.jobsite`, newJobsite);
  };

  const handleJobnameNameChange = (e: any) => {
    jobsiteRef.current = e;
  };
  return (
    <Card elevation={0} className="floorUnitBlockWrapper" style={{ marginBottom: '0', background: 'none' }}>
      <CardContent className="  " style={{ paddingTop: '4px', paddingBottom: '4px' }}>
        <Grid container spacing={2}>
          <Grid item lg={9} sm={9} xl={9} xs={9}>
            <div style={{ display: 'none' }}>
              <label>{getValues(`${name}.unitNumber`)}</label>
            </div>
            <Grid container spacing={2}>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput
                  // disabled={true}
                  name={`${name}.jobsite`}
                  onChange={(e: any) => handleJobnameNameChange(e)}
                  label={'Jobsite'}
                  validationQueryRoute={(value: string) =>
                    projectsApiKeyStore.checkDuplicateLotAddressJobsite(
                      getValues('projectID'),
                      getValues(`${name}.address`),
                      getValues(`${name}.unitID`),
                      getValues(`${name}.unitName`),
                      value
                    )
                  }
                />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput
                  name={`${name}.unitName`}
                  label="Lot/Unit"
                  validationQueryRoute={(value: string) =>
                    projectsApiKeyStore.checkDuplicateLotAddress(
                      getValues('projectID'),
                      getValues(`${name}.address`),
                      getValues(`${name}.unitID`),

                      value,
                      getValues(`${name}.jobsite`)
                    )
                  }
                  onChange={(e: any) => handleUnitNameChange(e)}
                />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput
                  name={`${name}.jobNumber`}
                  label={'Builder Job Number'}
                  validationQueryRoute={(value: string) =>
                    projectsApiKeyStore.checkDuplicateLotAddress(
                      getValues('projectID'),
                      getValues(`${name}.address`),
                      getValues(`${name}.unitID`),
                      getValues(`${name}.unitName`),
                      getValues(`${name}.jobsite`),
                      value
                    )
                  }
                />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput
                  name={`${name}.address`}
                  label="Address"
                  validationQueryRoute={(value: string) =>
                    projectsApiKeyStore.checkDuplicateLotAddress(
                      getValues('projectID'),
                      value,
                      getValues(`${name}.unitID`),
                      getValues(`${name}.unitName`),
                      getValues(`${name}.jobsite`)
                    )
                  }
                />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormInput name={`${name}.squareFeet`} label={'Square Feet'} />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormAutoCompleteSelectDynamic
                  name={`${name}.proctorResult`}
                  label="Proctor Result"
                  getQueryKeyConfig={() => proctorResultApiKeyStore.getProjectProctorResults(getValues('projectID'))}
                  optionsValueKey="proctorResultsID"
                  optionsLabelKey="proctorFileName"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={3} sm={3} xl={3} xs={3}>
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              {/* <FormCheckbox label="Create WO" name={`${name}.createWO`} /> */}
              <FormInput label="Building Permit#" name={`${name}.buildingPermit`} styleField={{ width: '180px' }} />
              {/* <FormCheckbox label="Sync With DUX" name={`${name}.syncWithDUX`} disabled={!syncWithDux} /> */}
              {onRemove && !!index && (
                <div style={{ marginLeft: 'auto', flex: '.5' }}>
                  <DeleteButton
                    data={undefined}
                    deleteMutationConfig={() => projectsApiKeyStore.deleteLot(getValues(`${name}.lotID`))}
                    onDeleted={() => onRemove(index)}
                  >
                    <>
                      <img src={Icons.Delete} alt="DELETE" />
                    </>
                  </DeleteButton>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
